import { render, staticRenderFns } from "./TravellerRequirements.vue?vue&type=template&id=5b5be6a7&lang=pug"
import script from "./TravellerRequirements.vue?vue&type=script&lang=js"
export * from "./TravellerRequirements.vue?vue&type=script&lang=js"
import style0 from "./TravellerRequirements.vue?vue&type=style&index=0&id=5b5be6a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports